<template>
  <div class="about-container">
    <div class="banner">
      <img class="img" :src="$env.imgUrl + 'banner-about.png'" alt="">
      <div class="banner-content">
        <div class="banner-title">关于我们</div>
        <div class="banner-title-en">About Us</div>
        <div class="banner-tab">
          <div class="banner-tab-item" :class="activeIndex === index ? 'sel' : ''" v-for="(item, index) in tabs" :key="index" @click="handleTabClick(index)">
            <div class="cn">{{ item.title }}</div>
            <div class="en">{{ item.enTitle }}</div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="activeIndex === 0">
      <div class="section1 page-flex-lr-center safe-area">
        <div class="lf">
          <pageTitle cn="人类共同愿景" en="Shared Future Vision" type="1"></pageTitle>
          <div class="common-title-d1 mt-20">人类命运共同体理念立足百年变局下全球依存共生的现实，倡导持久和平、共同繁荣、开放包容的世界秩序，为全球治理提供东方方案。</div>
          <div class="common-title-d1 mt-12">本次全球青少年PBL创新素养大会深度践行共商共建共享核心逻辑，以项目式学习为载体，组织各国青少年共同探究可持续发展、跨文化沟通等全球性议题。学生在真实问题解决中建立全球视野、协作意识与社会责任感，在双向文化交流中成长为参与全球治理、践行人类共同价值的青年使者。</div>
          <div class="common-title-d2 mt-12">The vision of building a community with a shared future for mankind answers the core epochal question: what kind of world do we want, and how shall we build it. Rooted in Marxist theories of social development and traditional Chinese philosophies of universal harmony, the framework advocates lasting peace, universal security, shared prosperity, openness and inclusiveness, and a clean global ecosystem. Against a turbulent global landscape, this vision delivers Chinese wisdom for global governance, calling for cross-civilization communication and joint problem-solving.</div>
        </div>
        <div class="rt">
          <img :src="$env.imgUrl + 's1.png?v=0720'" alt="">
        </div>
      </div>
      <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'home-bg-1.png);'">
        <div class="safe-area">
          <pageTitle cn="可持续发展目标" en="UN Sustainable Development Goals" type="2"></pageTitle>
          <div class="page-flex-lr-center">
            <div class="lf">
              <div class="common-title-d1 d1-1 mt-20">2015年联合国发布17项可持续发展目标（SDGs），覆盖生态、民生、经济、平等多领域，明确教育是推动全球可持续变革的核心驱动力。</div>
              <div class="common-title-d1 d1-1 mt-12">挑战赛四大赛道全部锚定SDGs核心议题，引导学生将可持续理念融入课题调研、实物创作与舞台展演，在完整项目实践中建立长期社会责任感，掌握跨学科解决全球现实问题的能力。</div>
              <div class="common-title-d2 d2-1 mt-12">The 17 UN SDGs, adopted in the 2030 Agenda for Sustainable Development, cover economy, society and ecological balance. The UN officially recognizes education as the most powerful catalyst to advance global sustainable transformation. All competition tracks of our summit are designed around SDG targets. Students integrate sustainable concepts into PBL research, creative works and stage presentations, building long-term environmental awareness and global social accountability.</div>
            </div>
            <div class="rt">
              <div class="page-flex-lr-center">
                <img class="s2-img" :src="$env.imgUrl + 's2-1.png'" alt="">
                <img class="s2-img" :src="$env.imgUrl + 's2-2.png'" alt="">
              </div>
              <div class="page-flex-lr-center">
                <img class="s2-img" :src="$env.imgUrl + 's2-3.png'" alt="">
                <img class="s2-img" :src="$env.imgUrl + 's2-4.png'" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section3 safe-area">
        <pageTitle cn="全球素养教育" en="Global Competence Education" type="1"></pageTitle>
        <div class="common-title-d1 mt-20 w60">本大会完整对标OECD全球胜任力标准，将国际理解教育融入完整赛事体系，让青少年跳出课本，在竞技、研学、跨校协作中锻炼综合能力，适配海外升学、国际交流、全球职业发展需求。</div>
        <div class="common-title-d2 mt-12 w60">This competition fully aligns with the OECD Global Competencies Standards, integrating international understanding education into a comprehensive competition framework. It enables young people to step beyond the confines of textbooks and develop their comprehensive skills through competition, research-based learning, and cross-school collaboration, thereby preparing them for overseas university admissions, international exchanges, and global career development.</div>
        <div class="page-flex-lr-center-between mt-20">
          <img class="s3-img" :src="$env.imgUrl + 'about-s3-1.png'" alt="">
          <img class="s3-img" :src="$env.imgUrl + 'about-s3-2.png'" alt="">
          <img class="s3-img" :src="$env.imgUrl + 'about-s3-3.png'" alt="">
        </div>
      </div>
      <div class="section4" :style="'background-image: url(' + $env.imgUrl + 'home-bg-1.png);'">
        <div class="safe-area">
          <div class="page-flex-lr-center">
            <div class="lf">
              <pageTitle cn="PBL教学内核" en="Core of PBL" type="2"></pageTitle>
              <div class="common-title-d1 d1-1 mt-20">PBL（Project-Based Learning，项目式学习）起源于20世纪50年代医学教育体系，是问题驱动、全流程闭环的沉浸式教学模式。在导师引导下，学生独立完成选题调研、方案设计、落地执行、成果评估全流程，围绕真实产品、公益项目、创新方案开展深度探究。</div>
              <div class="common-title-d2 d2-1 mt-20">PBL (Project-Based Learning) originated from the medical education system in the 1950s and is an immersive teaching model driven by problems and featuring a full-process closed loop. Under the guidance of mentors, students independently complete the entire process of topic selection and research, scheme design, implementation, and outcome evaluation, conducting in-depth exploration around real products, public welfare projects, and innovative solutions.</div>
            </div>
            <div class="rt">
              <img class="s4-img" :src="$env.imgUrl + 's4.png?v=0720'" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="section5 safe-area">
        <div class="d8">完整PBL体系重点培育青少年5C核心素养：</div>
        <div class="d9">The complete PBL system focuses on cultivating the 5C core competencies of young people:</div>
        <div class="page-flex-lr-center-between">
          <div class="flip-card">
            <div class="flip-inner">
              <img class="flip-front s5-img" :src="$env.imgUrl + 'about-s5-1.png?v=0720'" alt="">
              <img class="flip-back s5-img" :src="$env.imgUrl + 'about-s5-1a.png'" alt="">
            </div>
          </div>
          <div class="flip-card">
            <div class="flip-inner">
              <img class="flip-front s5-img" :src="$env.imgUrl + 'about-s5-2.png?v=0720'" alt="">
              <img class="flip-back s5-img" :src="$env.imgUrl + 'about-s5-2a.png'" alt="">
            </div>
          </div>
          <div class="flip-card">
            <div class="flip-inner">
              <img class="flip-front s5-img" :src="$env.imgUrl + 'about-s5-3.png?v=0720'" alt="">
              <img class="flip-back s5-img" :src="$env.imgUrl + 'about-s5-3a.png'" alt="">
            </div>
          </div>
          <div class="flip-card">
            <div class="flip-inner">
              <img class="flip-front s5-img" :src="$env.imgUrl + 'about-s5-4.png?v=0720'" alt="">
              <img class="flip-back s5-img" :src="$env.imgUrl + 'about-s5-4a.png'" alt="">
            </div>
          </div>
          <div class="flip-card">
            <div class="flip-inner">
              <img class="flip-front s5-img" :src="$env.imgUrl + 'about-s5-5.png?v=0720'" alt="">
              <img class="flip-back s5-img" :src="$env.imgUrl + 'about-s5-5a.png'" alt="">
            </div>
          </div>
        </div>

        <div class="d8">标准PBL项目包含七大核心设计要素：</div>
        <div class="d9">The standard PBL project encompasses seven core design elements:</div>

        <div class="page-flex-lr-center-between">
          <img class="s5-img1" :src="$env.imgUrl + 'about-s5-21.png?v=0720'" alt="">
          <img class="s5-img1" :src="$env.imgUrl + 'about-s5-22.png?v=0720'" alt="">
          <img class="s5-img1" :src="$env.imgUrl + 'about-s5-23.png?v=0720'" alt="">
          <img class="s5-img1" :src="$env.imgUrl + 'about-s5-24.png?v=0720'" alt="">
          <img class="s5-img1" :src="$env.imgUrl + 'about-s5-25.png?v=0720'" alt="">
          <img class="s5-img1" :src="$env.imgUrl + 'about-s5-26.png?v=0720'" alt="">
          <img class="s5-img1" :src="$env.imgUrl + 'about-s5-27.png?v=0720'" alt="">
        </div>
      </div>
    </template>
    <template v-if="activeIndex === 1">
      <div class="section1-r safe-area page-flex-lr-center">
        <div class="lf">
          <pageTitle cn="校内课程矩阵" en="Campus Curriculum System" type="1"></pageTitle>
          <div class="common-title-d1 mt-20">本次大会融入国际理解教育体系，面向国内全日制中小学打造校本延时、社团拓展、研学实践一体化人文素养培养方案，全面响应“双减”政策与国际理解教育国家导向。</div>
          <div class="common-title-d2 mt-12">This conference integrates Education for International Understanding, offering a integrated humanities literacy program for full-time primary and secondary schools in China—covering after-school sessions, club activities, and study tours—fully responding to the “double reduction” policy and national guidelines for international understanding education.</div>
        </div>
        <div class="rt">
          <img class="s1r-img" :src="$env.imgUrl + 'sr1.png'" alt="">
        </div>
      </div>
      <div class="section2-r" :style="'background-image: url(' + $env.imgUrl + 'home-bg-1.png);'">
        <div class="safe-area">
          <pageTitle cn="四维培育方向" en="Four Core Training Goals" type="2"></pageTitle>
          <div class="page-flex-lr-center-between">
            <img class="s2r-img" :src="$env.imgUrl + 'sr2-1.png?v=0720'" alt="">
            <img class="s2r-img" :src="$env.imgUrl + 'sr2-2.png?v=0720'" alt="">
            <img class="s2r-img" :src="$env.imgUrl + 'sr2-3.png?v=0720'" alt="">
            <img class="s2r-img" :src="$env.imgUrl + 'sr2-4.png?v=0720'" alt="">
          </div>
        </div>
      </div>
      <div class="section3-r safe-area">
        <pageTitle cn="核心育人目标" en="Core Educational Mission" type="1"></pageTitle>
        <div class="common-title-d1 mt-20 w60">培育兼具民族文化自信与全球视野的青少年，建立多层身份认知：社区参与者、中华文化传承者、中国青年代表、全球公民、自然守护者，以青年力量推进人类命运共同体建设。</div>
        <div class="common-title-d2 mt-12 w60">Cultivate young people who possess both cultural confidence in their national heritage and a global perspective, and establish a multi-layered identity recognition: community participants, inheritors of Chinese culture, representatives of Chinese youth, global citizens, and guardians of nature, using the power of youth to promote the construction of a community with a shared future for mankind.</div>
        <div class="page-flex-lr-center-between">
          <img class="s3r-img" :src="$env.imgUrl + 'sr3-1.png?v=0720'" alt="">
          <img class="s3r-img" :src="$env.imgUrl + 'sr3-2.png?v=0720'" alt="">
          <img class="s3r-img" :src="$env.imgUrl + 'sr3-3.png?v=0720'" alt="">
          <img class="s3r-img" :src="$env.imgUrl + 'sr3-4.png?v=0720'" alt="">
          <img class="s3r-img" :src="$env.imgUrl + 'sr3-5.png?v=0720'" alt="">
        </div>
      </div>

    </template>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: 0,
      tabs: [
        {
          title: '项目发展背景',
          enTitle: 'Project Development Background'
        },
        {
          title: '项目完整体系',
          enTitle: 'Complete Program System'
        }
      ]
    }
  },
  watch: {
    '$route' (to) {
      this.activeIndex = to.query.index ? Number(to.query.index) : 0
    }
  },
  created() {
    this.activeIndex = this.$route.query.index ? Number(this.$route.query.index) : 0
    this.$store.dispatch('SET_MENUINDEX', 1)
  },
  methods: {
    handleTabClick (index) {
      this.activeIndex = index
      this.$router.replace({ query: { index } })
    }
  }
}
</script>
<style lang="less" scoped>
.about-container{
  width: 100vw;
  overflow: hidden;
}
.banner{
  width: 100vw;
  position: relative;
  min-height: 300px;
  .img{
    width: 100%;
    height: auto;
  }
  .banner-content{
    position: absolute;
    top: 200px;
    left: 0;
    right: 0;
    text-align: center;
  }
  .banner-title{
    color: #fff;
    font-family: regular;
    font-size: 58px;
    margin-bottom: 10px;
  }
  .banner-title-en{
    color: #fff;
    font-family: alim;
    font-size: 18px;
  }
  .banner-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .banner-tab-item{
      margin: 20px 10px;
      width: 240px;
      height: 46px;
      border-radius: 46px;
      text-align: center;
      background-color: #fff;
      color: #000;
      cursor: pointer;
      padding-top: 8px;

      .cn{
        font-family: systh;
        font-size: 16px;
        line-height: 20px;
      }
      .en{
        font-family: systm;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }
  .sel{
    background-color: #C92739 !important;
    color: #FFF !important;
  }
}
// .d1{
//   font-family: systm;
//   font-size: 14px;
//   color: #000;
// }
// .d2{
//   font-family: systm;
//   font-size: 10px;
//   color: #666;
// }
.d1-1{
  color: #fff;
}
.d2-1{
  color: #FD8E86;
}
.mt-12{
  margin-top: 12px;
}
.mt-20{
  margin-top: 20px;
}
.w60{
  width: 60%;
}
.d8{
  color: #C9273A;
  font-size: 20px;
  font-family: systh;
  margin-top: 40px;
}
.d9{
  color: #C9273A;
  font-size: 10px;
  font-family: systh;
}
.section1{
  .lf{
    width: 45%;
  }
  .rt{
    width: 55%;
    img{
      width: 90%;
      height: 320px;
      object-fit: contain;
      border-radius: 20px;
      margin-left: 30px;
    }
  }
}
.section2{
  padding: 100px 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .lf{
    width: 40%;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .rt{
    width: 60%;
    .s2-img{
      width: 48%;
      display: block;
      margin: 0 auto 20px;
    }
  }
}
.s3-img{
  width: 32%;
}
.section3{
  padding-bottom: 40px;
}
.section4{
  padding: 80px 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .lf{
    width: 65%;
  }
  .rt{
    width: 35%;
    padding-left: 40px;
    box-sizing: border-box;
  }
}
.s4-img{
  width: 100%;
}
.s5-img{
  width: 100%;
  display: block;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.flip-card{
  width: 19%;
  margin-top: 30px;
  perspective: 1000px;  // 3D 透视
  cursor: pointer;
  .flip-inner{
    position: relative;
    width: 100%;
    transition: transform 0.6s;
    transform-style: preserve-3d;
  }
  &:hover .flip-inner{
    transform: rotateY(180deg);  // 悬停翻转
  }
  .flip-front, .flip-back{
    width: 100%;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  }
  .flip-back{
    position: absolute;
    top: 0;
    left: 0;
    transform: rotateY(180deg);  // 背面预旋转
  }
}
.s5-img1{
  width: 13.6%;
  margin-top: 30px;
}
.section5{
  padding-bottom: 80px;
}
.section1-r{
  padding-top: 30px;
  padding-bottom: 40px;
  .lf{
    width: 30%;
  }
  .rt{
    width: 70%;
    padding-left: 60px;
    box-sizing: border-box;
    img{
      width: 100%;
    }
  }
}
.section2-r{
  padding: 100px 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.s2r-img{
  width: 24%;
  margin-top: 20px;
}
.section3-r{
  padding-bottom: 80px;
}
.s3r-img{
  width: 19%;
  margin-top: 20px;
}
</style>
